<div class="elementinnerholder">
    <div #mapRef style="width:100%;" [style.height.px]="elementheight"> </div>
</div>


